"use client";

import { motion, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

interface SectionRevealProps {
  children: ReactNode;
  delay?: number;
}

export function SectionReveal({ children, delay = 0 }: SectionRevealProps) {
  const reduce = useReducedMotion() ?? false;

  return (
    <motion.div
      initial={{ opacity: 0, y: reduce ? 0 : 34, filter: reduce ? "none" : "blur(8px)" }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, amount: "some", margin: "0px 0px -80px 0px" }}
      transition={{
        duration: reduce ? 0.01 : 0.72,
        delay: reduce ? 0 : delay,
        ease: [0.2, 0, 0, 1],
      }}
      className="will-change-transform"
    >
      {children}
    </motion.div>
  );
}
